import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Train = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M20 17V6c.001-.188-.032-1.434-1.129-2.665C17.715 2.037 16.509 2 16.375 2H7.621c-.224 0-1.399.065-2.503 1.351C4.031 4.616 4 5.862 4 6v11a2 2 0 0 0 2 2h1l-2 3h2.353l.667-1h8l.677 1H19l-2-3h1a2 2 0 0 0 2-2zM10 4h4v2h-4V4zM8 17.03l-2-.039V15h2v2.03zM6 13V8h12v5H6zm10 4v-2h2v2h-2z", key: "k0" })));
});
Train.displayName = 'Train';
export var TrainDimensions = { height: 24, width: 24 };
